import React, { useState } from "react";
import C2CCustomPopup from "../../../common/Popups/C2CCustomPopup";
import "./saveTemplateButton.scss";
import FormInputWithHeader from "../../../common/FormInputWithHeader";
import { SECTIONAL_TEMPLATES } from "../../ERXConstants/constants";

function SaveTemplateButton({
  comp,
  onSave,
  sectionalTemplateList,
  selectedSectionTemp,
}) {
  // temp states
  const [saveTemplate, setSaveTemplate] = useState(false);
  const [templateError, setTemplateError] = useState(false);
  const [templateName, setTemplateName] = useState("");

  const onSaveTemplateHandleClick = () => {
    setSaveTemplate(true);
    setTemplateError(false);
    if (selectedSectionTemp[comp.templateTitle]?.template_name) {
      setTemplateName(selectedSectionTemp[comp.templateTitle]?.template_name);
    } else {
      setTemplateName("");
    }
  };
  const saveTemplateApi = () => {
    if (checkDuplicateName(templateName)) {
      setTemplateError(true);
    } else {
      onYesCall();
    }
  };
  const onYesCall = () => {
    onSave(comp, templateName);
    setSaveTemplate(false);
  };

  const handleTemplateCancel = () => {
    setSaveTemplate(false);
  };
  const checkDuplicateName = (val) => {
    if (
      comp.templateTitle ===
        SECTIONAL_TEMPLATES.SUGGESTED_INVESTIGATION_TEMPLATE &&
      sectionalTemplateList?.suggested_investigation_template?.length > 0
    ) {
      let ind =
        sectionalTemplateList.suggested_investigation_template.findIndex(
          (obj) =>
            obj.template_name?.toLowerCase()?.trim() ===
            val?.toLowerCase()?.trim()
        );
      return ind > -1;
    }
    if (
      comp.templateTitle === SECTIONAL_TEMPLATES.DRUG_TEMPLATE &&
      sectionalTemplateList?.drug_templates?.length > 0
    ) {
      let ind = sectionalTemplateList.drug_templates.findIndex(
        (obj) =>
          obj.template_name?.toLowerCase()?.trim() ===
          val?.toLowerCase()?.trim()
      );
      return ind > -1;
    }
    if (
      comp.templateTitle === SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE &&
      sectionalTemplateList?.dignosis_template?.length > 0
    ) {
      let ind = sectionalTemplateList.dignosis_template.findIndex(
        (obj) =>
          obj.template_name?.toLowerCase()?.trim() ===
          val?.toLowerCase()?.trim()
      );
      return ind > -1;
    }
  };
  const onTemplateNameChange = (val) => {
    setTemplateName(val);
  };

  const displaySaveTemplateInputButtonUi = () => {
    return (
      <div className="save-template-input-btns-error-wrapper">
        <div className="save-template-input-btn-container">
          <FormInputWithHeader
            type="text"
            placeholder={comp?.inputPlaceholder ?? "Template Name"}
            maxLimit={250}
            value={templateName}
            handleOnChangeInput={(e) => onTemplateNameChange(e.target.value)}
          />
          <div>
            {templateError ? (
              <div className="save-template-save-cancel-yes-no-btn-wrapper">
                <div
                  className="save-template-cancel-no-btn"
                  onClick={handleTemplateCancel}
                >
                  No
                </div>
                <div
                  className="save-template-yes-btn"
                  onClick={onYesCall}
                  disabled={templateName === ""}
                >
                  Yes
                </div>
              </div>
            ) : (
              <div className="save-template-save-cancel-yes-no-btn-wrapper">
                <div
                  className="save-template-cancel-no-btn"
                  onClick={handleTemplateCancel}
                >
                  Cancel
                </div>
                <div
                  className={`save-template-save-btn ${
                    templateName === "" ? "disabled" : ""
                  }`}
                  disabled={templateName === ""}
                  onClick={saveTemplateApi}
                >
                  Save
                </div>
              </div>
            )}
          </div>
        </div>
        {templateError && (
          <div className="save-template-error">
            The template already exists. Would you like to override?
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div
        className="save-template-section-button"
        onClick={onSaveTemplateHandleClick}
      >
        Save Template
      </div>
      {saveTemplate && (
        <C2CCustomPopup
          openPopup={saveTemplate}
          popupHeading="Save Template"
          dialogClassName="erx-save-template-popup"
          handleClosePopup={handleTemplateCancel}
        >
          {displaySaveTemplateInputButtonUi()}
        </C2CCustomPopup>
      )}
    </div>
  );
}

export default SaveTemplateButton;
